import _keccak from "./keccak";
import _shake from "./shake";
var exports = {};
const createKeccak = _keccak;
const createShake = _shake;
exports = function (KeccakState) {
  const Keccak = createKeccak(KeccakState);
  const Shake = createShake(KeccakState);
  return function (algorithm, options) {
    const hash = typeof algorithm === "string" ? algorithm.toLowerCase() : algorithm;
    switch (hash) {
      case "keccak224":
        return new Keccak(1152, 448, null, 224, options);
      case "keccak256":
        return new Keccak(1088, 512, null, 256, options);
      case "keccak384":
        return new Keccak(832, 768, null, 384, options);
      case "keccak512":
        return new Keccak(576, 1024, null, 512, options);
      case "sha3-224":
        return new Keccak(1152, 448, 6, 224, options);
      case "sha3-256":
        return new Keccak(1088, 512, 6, 256, options);
      case "sha3-384":
        return new Keccak(832, 768, 6, 384, options);
      case "sha3-512":
        return new Keccak(576, 1024, 6, 512, options);
      case "shake128":
        return new Shake(1344, 256, 31, options);
      case "shake256":
        return new Shake(1088, 512, 31, options);
      default:
        throw new Error("Invald algorithm: " + algorithm);
    }
  };
};
export default exports;